export interface Page<T> {
  number: number;
  totalElements: number;
  totalPages: number;
  content: T[];
  pageable: Pageable;
}

export interface Pageable {
  /** page number, 0 based */
  page: number;
  /** size of page */
  size: number;
  sort?: Sort;
  search?: string;
  pageNumber?: number;
}

export interface Sort {
  field: string;
  order: SortOrder;
}

export type SortOrder = 'asc' | 'desc';

export class EntityRef {
  public id: string;

  constructor(id?: string) {
    if (id) {
      this.id = id;
    }
  }
}

export function emptyPage(): Page<never> {
  return {
    number: 0,
    totalElements: 0,
    totalPages: 0,
    content: [],
    pageable: defaultPageable()
  };
}

export function defaultPageable(): Pageable {
  return {
    page: 0,
    size: 10,
  };
}

export function singlePageable(): Pageable {
  return {
    page: 0,
    size: 1,
  };
}

export function fullPageable(): Pageable {
  return {
    page: 0,
    size: 10000,
  };
}

export function toUrlParams(pageable: Pageable) {
  let params = `page=${pageable.page}&size=${pageable.size}`;
  if (pageable.search) {
    params += `search=${pageable.search}`;
  }
  if (pageable.sort) {
    params += `sort=${pageable.sort}`;
  }
  return params;
}
